module.exports = __webpack_public_path__ + "static/vision-and-visionaries-7ffd1cdd8fcad85e43ffd7479d0f8040.jpg";